/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/remove': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g class="nc-icon-wrapper" _fill="#272c33"><path pid="0" data-color="color-2" d="M5.9 11.5L8 9.4l2.1 2.1 1.4-1.4L9.4 8l2.1-2.1-1.4-1.4L8 6.6 5.9 4.5 4.5 5.9 6.6 8l-2.1 2.1z"/><path pid="1" d="M15 0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 14H2V2h12v12z"/></g>'
  }
})
